import { ABTestCookie, ABTestCookieValue } from '@as-react/common-types';
import { CookieUtil } from './CookieUtil';

export class HybridCookieUtil {
  private readonly cookies: { [cookieName: string]: string | undefined } | undefined;

  constructor(cookies = undefined) {
    this.cookies = cookies;
  }

  public getCookie(cookieName: ABTestCookie): string | undefined {
    let abCookie: string | undefined;
    if (typeof document !== 'undefined' && document?.cookie) {
      // client side
      abCookie = CookieUtil.get(cookieName) || undefined;
    } else if (this.cookies) {
      // server side
      abCookie = this.cookies?.[cookieName];
    }
    return abCookie?.toUpperCase();
  }

  public hasABCookie(cookieName: ABTestCookie): boolean | undefined {
    const abCookie: string | undefined = this.getCookie(cookieName);
    return abCookie ? [ABTestCookieValue.B, ABTestCookieValue.C].includes(abCookie as ABTestCookieValue) : undefined;
  }

  public hasBCookie(cookieName: ABTestCookie): boolean {
    const abCookie: string | undefined = this.getCookie(cookieName);

    return abCookie?.toUpperCase() === ABTestCookieValue.B;
  }

  public hasCCookie(cookieName: ABTestCookie): boolean {
    const abCookie: string | undefined = this.getCookie(cookieName);

    return abCookie?.toUpperCase() === ABTestCookieValue.C;
  }
}
